import styled from 'styled-components';

export {Tab} from './Tabs'
export {default as Tabs} from './Tabs'

export {default as Modal} from './Modal'
export {default as Filter} from './Filter';
export {default as PageNotFound} from './404';
export {default as GroupTitle} from './GroupTitle';
export {default as PageSection} from './PageSection'
export {default as FileUploader} from './FileUploader'
export {default as withAuthentication} from './authenticated';
export {default as PageTitle} from './PageTitle';
export {default as BreadCrumbs} from './BreadCrumbs';

export * from './forms'
export * from './Button';
export * from '../modules/layout/components/Gradients';
export * from './CellRenderers'

export const InlineDiv = styled.div`
  display: inline-block;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/components/index.js